module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/loader-7c8805933272932b28e6dcad2db9107c.gif";